import { IError } from '../types/IRootState';
import { IRootState, ISearchType } from '@/store/types/IRootState';

const rootStateGetters = {
  getIsLoadingFlag(state: IRootState): boolean {
    return state.isLoading;
  },
  getError(state: IRootState): IError {
    return state.error;
  },
  getSelectedSearchFieldOption(state: IRootState): ISearchType {
    return state.selectedSearchFieldOption;
  },
  getAllSearchTypes( state: IRootState): ISearchType[] {
    return state.searchTypes;
  },
  getCurrentSearchType(state: IRootState): ISearchType {
    return state.selectedSearchFieldOption;
  },
  getItemsCount(state: IRootState): number {
    return  state.itemsCounter;
  },
  getMaxItems(state: IRootState): number {
    return state.currentMaxItems;
  },
  isShowingAllItems(state: IRootState): boolean {
    return state.itemsCounter > state.currentMaxItems;
  },
  getSearchString(state: IRootState): string {
    return state.searchString;
  },
  getHasFiltersFlag(state: IRootState): boolean {
    return state.hasFilters;
  },
  userProjectName(state: IRootState): string | null | undefined {
    return state.auth.user && state.auth.user.nome_projeto;
  },
  kmUrlBase(state: IRootState): string | null | undefined  {
      return state.auth.user && state.auth.user.url_base;
  },
};
export default rootStateGetters;
